import type { SerializedStyles, Theme } from "@emotion/react";
import type { ReactNode } from "react";

import * as styles from "./Item.styles";

interface Props {
  children: ReactNode;
  customStyles?:
    | SerializedStyles
    | (SerializedStyles | ((theme: Theme) => SerializedStyles))[]
    | ((theme: Theme) => SerializedStyles);
}

const Item = ({ children, customStyles }: Props) => {
  return <div css={[styles.slideItem, customStyles]}>{children}</div>;
};

Item.displayName = "NewCarousel.Item";

export { Item };
